
export enum NullHandling {
  NATIVE = 'NATIVE',
  NULLS_FIRST = 'NULLS_FIRST',
  NULLS_LAST = 'NULLS_LAST'
}
